import { coursesTags } from "../context/tags";

function gaEvent(type, tag) {
  if (typeof window !== "undefined" && !!window.gtag) {
    window.gtag("event", type, {
      send_to: tag,
    });
  }
}

export function track(course) {
  switch (true) {
    case course.includes("INTRO"):
      gaEvent("conversion", "AW-881862310/RjOpCM3gm6cBEKbNwKQD");
      break;
    case course === coursesTags.BC_JAVASCRIPT:
      gaEvent("lead", "AW-881862310/BXQqCNm_lKcBEKbNwKQD");
      break;
    case course === coursesTags.BC_SALESFORCE:
      gaEvent("lead", "AW-881862310/cKjUCM_B3ZYDEKbNwKQD");
      break;
    default:
      return;
  }
}
